import m from "../../geodata/es2015/russiaCrimeaLow";
window.am4geodata_russiaCrimeaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/russiaCrimeaLow.js
// module id = null
// module chunks = 